// // src/components/home/CurrentStatusCard.jsx
// import React from "react";
// import { MapPin, Clock } from "lucide-react";

// const CurrentStatusCard = () => {
//   const userData = JSON.parse(localStorage.getItem("user"));
//   const locationName =
//     Array.isArray(userData?.locations) && userData.locations.length > 0
//       ? userData.locations[0].location_name
//       : null;
//   return (
//     <div className="card shadow-sm">
//       <div className="card-body p-5">
//         <p className="fw-bold mb-4">Current Status</p>
//         <div className="d-flex align-items-center mb-3 gap-3">
//           <MapPin size={20} className="" />
//           <div>
//             <p className="mb-0">Current Location</p>
//             <small className="">{locationName || "No Location Found"}</small>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CurrentStatusCard;


import React from "react";
import { MapPin, Map } from "lucide-react";
import { useGeolocated } from "react-geolocated";
import { usePermissions } from "../../context/PermissionContext";
import { pointInPolygon } from "../../utils/PointInPolygon";

const CurrentStatusCard = () => {
  const { assignedLocations } = usePermissions();
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 10000,
    });

  // Determine current location based on geolocation
  const getCurrentLocation = () => {
    if (!isGeolocationAvailable) {
      return "Geolocation not supported by this browser.";
    }
    if (!isGeolocationEnabled) {
      return "Geolocation is disabled. Please enable location services.";
    }
    if (!coords?.latitude || !coords?.longitude) {
      return "Fetching location...";
    }

    const userPoint = { lat: coords.latitude, lng: coords.longitude };
    const currentLocation = assignedLocations.find((location) =>
      pointInPolygon(userPoint, location.polygons)
    );

    return currentLocation
      ? currentLocation.location_name
      : "Not in an assigned location";
  };

  // Get list of assigned locations
  const assignedLocationsList = Array.isArray(assignedLocations)
    ? assignedLocations
    : [];

  return (
    <div className="card shadow-sm">
      <div className="card-body p-5">
        <p className="fw-bold mb-4">Current Status</p>
        <div className="d-flex align-items-center mb-3 gap-3">
          <MapPin size={20} className="" />
          <div>
            <p className="mb-0">Current Location</p>
            <small className="">{getCurrentLocation()}</small>
          </div>
        </div>
        <div className="d-flex align-items-center mb-3 gap-3">
          <Map size={20} className="" />
          <div>
            <p className="mb-0">Assigned Locations</p>
            {assignedLocationsList.length > 0 ? (
              <ul className="mb-0 ps-3">
                {assignedLocationsList.map((location, index) => (
                  <li key={index} className="text-sm">
                    {location.location_name}
                  </li>
                ))}
              </ul>
            ) : (
              <small>No assigned locations found.</small>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentStatusCard;